var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    viewBox: "0 0 120 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h120v80H0z",
    fill: "#36f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40 0 80h120z",
    fill: "red"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 37v6l120-6v6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 40 0 5V0h5zl55-40h5v5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 40 57 0h6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRe);
export default __webpack_public_path__ + "static/media/re.6efdf87063e104515222073c7f96da14.svg";
export { ForwardRef as ReactComponent };